/**
 * 自定义助手场景（设置中心「场景定制」维护，聊天页场景入口展示）
 * ------------------------------------------------------------
 * 条目存在账号下的 chat.scene；失败抛错，不回退本机演示数据。
 * list 为跨页面共享的响应式状态：设置页保存/删除后，聊天页场景入口即时更新。
 */
import { reactive } from 'vue'
import { assistantApi, type SceneRow, type SceneDraft } from '@/data/api/assistant'

export type { SceneRow, SceneDraft }

export const customScenes = reactive({ list: [] as SceneRow[], loaded: false, error: '' })

export async function loadCustomScenes(): Promise<void> {
  try {
    customScenes.list = await assistantApi.scenes()
    customScenes.error = ''
  } catch (e) {
    customScenes.error = e instanceof Error ? e.message : '场景没有读出来'
  } finally {
    customScenes.loaded = true
  }
}

/** 保存（新建或更新）后刷新共享列表；场景名非法等后端 400 直接抛给调用方展示 */
export async function saveCustomScene(scene: Partial<SceneRow> & { name: string }): Promise<void> {
  await assistantApi.saveScene(scene)
  await loadCustomScenes()
}

export async function removeCustomScene(id: string): Promise<void> {
  await assistantApi.removeScene(id)
  await loadCustomScenes()
}
